<div class="empty-state-wrapper">
  <div class="icon-wrapper">
    <i class="bi bi-search"></i>
  </div>
  <span class="text mt-3">{{ "No-Results-Found" | translate }}</span>
</div>
